module.exports = __webpack_public_path__ + "static/img/cchj3.304f938a.png";